const SENSITIVE_CONFIG_KEYS = new Set(['nonce', 'token'])

export function configLogValue(key: string, value: unknown) {
	return SENSITIVE_CONFIG_KEYS.has(key) ? '[redacted]' : value
}

export function configLogValues(values: Record<string, unknown>) {
	return Object.keys(values).reduce<Record<string, unknown>>(
		(redacted, key) => {
			redacted[key] = configLogValue(key, values[key])
			return redacted
		},
		{},
	)
}
